import { SlidersEffects } from './sliders.effect';

export const effects = [SlidersEffects];
export * from './sliders.effect';
